module.exports = __webpack_public_path__ + "static/media/calculator.33882563.jpg";